import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { UiModule } from '../../../../components/ui.module';
import { ReviewManagementBranchLocation } from '../../../../types/usage';

@Component({
  selector: 'app-pan-cell-review-management-activity',
  imports: [UiModule, RouterModule],
  templateUrl: './cell-review-management-activity.component.html',
  styleUrl: './cell-review-management-activity.component.scss',
})
export class CellReviewManagementActivityComponent implements ICellRendererAngularComp {
  public params!: ICellRendererParams<ReviewManagementBranchLocation>;

  agInit(params: ICellRendererParams<ReviewManagementBranchLocation>) {
    this.params = params;
  }

  refresh(params: ICellRendererParams<ReviewManagementBranchLocation>) {
    this.params = params;
    return true;
  }
}
